// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner-container[data-v-3c49b248]{position:relative;width:100%;padding-top:50%}.banner-container .banner-frame[data-v-3c49b248]{position:absolute;top:0;bottom:0;left:0;right:0}.banner-container .banner-frame[data-v-3c49b248]  .media-container{height:100%;width:100%}.banner-container .banner-frame[data-v-3c49b248]  .media-container img{height:100%;width:100%;object-fit:cover}", ""]);
// Exports
module.exports = exports;
